module.exports = __webpack_public_path__ + "static/img/defaultImg.e1e4269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defaultImg.png
// module id = 6zzy
// module chunks = 1